import type { SectionId } from '../../utils/constants.js';

const SECTION_META: Record<SectionId, { title: string; subtitle: string }> = {
  overview: { title: 'Обзор майнинга',   subtitle: 'Мониторинг ферм в реальном времени' },
  rates:    { title: 'Курсы криптовалют', subtitle: 'Актуальные котировки и динамика 24ч' },
  spot:     { title: 'Спот портфель',     subtitle: 'Позиции, цели фиксации и DCA-стратегия' },
  earnings: { title: 'Доходы',            subtitle: 'История вознаграждений по периодам' },
  payments: { title: 'История выплат',    subtitle: 'Полный реестр выплат' },
  settings: { title: 'Настройки',         subtitle: 'Параметры дашборда' },
};

interface HeaderProps {
  section: SectionId;
  timeoutIndex: number;
  onTimeoutChange: (idx: number) => void;
  theme: string;
  onThemeToggle: () => void;
  onMenuToggle: () => void;
}

function todayIso(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function Header({ section }: HeaderProps) {
  const meta = SECTION_META[section];

  return (
    <section class="header">
      <h1 class="page-title">{meta.title}</h1>
      <p class="page-subtitle">{meta.subtitle}</p>
      <span class="header-date">{todayIso()}</span>
    </section>
  );
}
